export default function ignoreCacheReducer
    (state = { error:'', success:'', processing:false}, action)
{
    switch (action.type) {
        case 'CACHE_IGNORE_SUCCESS':
            return {...state, ...{success: action.success}};

        case 'CACHE_IGNORE_ERROR':
            return {...state, ...{error: action.error}};

        case 'CACHE_IGNORE_PROCESSING':
            return {...state, ...{processing: action.processing}};

        default: return state;
    }
}